const DropArrowMiddleIcon = ({
  color = 'currentColor',
  className = 'dropdown-icon'
}) => {
  return (
    <svg
      width="14"
      height="8"
      className={className}
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L7 7L13 1"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DropArrowMiddleIcon;
